.Alert {
  align-items: flex-start;
  background-color: var(--rv-surface);
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-lg);
  color: var(--rv-fg-1);
  display: grid;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-sm);
  gap: var(--rv-space-3);
  grid-template-columns: auto 1fr;
  padding: var(--rv-space-3) var(--rv-space-4);
  position: relative;
  width: 100%;
}

.Alert.default {
  background-color: var(--rv-surface);
  color: var(--rv-fg-1);
}

.Alert.success {
  background-color: var(--rv-success-bg);
  border-color: var(--color-green-200);
}

.Alert.success .AlertIcon,
.Alert.success svg {
  color: var(--rv-success-ink);
}

.Alert.warn,
.Alert.warning {
  background-color: var(--rv-warning-bg);
  border-color: var(--color-yellow-200);
}

.Alert.warn .AlertIcon,
.Alert.warning .AlertIcon,
.Alert.warn svg,
.Alert.warning svg {
  color: var(--rv-warning-ink);
}

.Alert.danger,
.Alert.destructive {
  background-color: var(--rv-danger-bg);
  border-color: var(--color-red-200);
}

.Alert.danger .AlertIcon,
.Alert.destructive .AlertIcon,
.Alert.danger svg,
.Alert.destructive svg {
  color: var(--rv-danger-ink);
}

.Alert.info {
  background-color: var(--rv-info-bg);
  border-color: var(--color-blue-200);
}

.Alert.info .AlertIcon,
.Alert.info svg {
  color: var(--rv-info-ink);
}

/* Dark mode: the status borders above use fixed pale `--color-*-200` primitives
   that don't adapt to the mode, while the fills are dark ~14% tints — so the
   border reads as one of the palest, loudest things on the page. Drop each
   border to the alpha-50 variant of its own fill hue: same color, just slightly
   more opaque than the fill, so it stays visible without contrasting harshly. */
html[data-color-mode='dark'] {
  & .Alert.success {
    border-color: var(--color-green-500-alpha-50);
  }

  & .Alert.warn,
  & .Alert.warning {
    border-color: var(--color-orange-500-alpha-50);
  }

  & .Alert.danger,
  & .Alert.destructive {
    border-color: var(--color-red-500-alpha-50);
  }

  & .Alert.info {
    border-color: var(--color-blue-500-alpha-50);
  }
}

.AlertIcon {
  color: var(--rv-fg-3);
  flex-shrink: 0;
  height: var(--rv-icon-sm);
  margin-top: var(--rv-space-1);
  width: var(--rv-icon-sm);
}

.AlertContent {
  display: flex;
  flex-direction: column;
  gap: var(--space-xxs);
}

.AlertTitle {
  color: var(--rv-fg-1);
  font-weight: var(--rv-w-semibold);
  letter-spacing: var(--rv-track-tight);
  line-height: var(--rv-lh-snug);
}

.AlertDescription {
  color: var(--rv-fg-2);
  font-size: var(--rv-text-sm);
  line-height: var(--rv-lh-normal);
}
